// extracted by mini-css-extract-plugin
module.exports = {"component":"MemosPage_component__3tajF","header":"MemosPage_header__1bYmd","main":"MemosPage_main__1QhyK"};